import PropTypes from 'prop-types';
import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import R from 'ramda';
import Cell from '../Cell';
import classNames from 'classnames';

import styles from './image-testimonial.css';

const { div, p, img } = hh(h);

const ImageTestimonial = ({
    image,
    quote,
    author,
    authorDetail,
    theme = 'one',
    side = 'left'
}) => {
    return (
        h(Cell, {width: false, padding: ['bottom']}, [
            div({className: classNames(styles.container, R.prop(side, styles))}, [
                img({alt: 'Image underneath quote', src: image, className: classNames(styles.image, R.prop(`${side}Image`, styles))}),
                div({
                    className: classNames(
                        styles.quoteContainer,
                        R.prop(`${side}QuoteContainer`, styles)
                    )
                }, [
                    p({
                        className: classNames(
                            styles.quote,
                            R.prop(theme, styles)
                        )
                    }, quote),
                    div({className: styles.authorContainer}, [
                        p({className: styles.author}, author),
                        p({className: styles.authorDetail}, authorDetail)])])])
        ])
    );
};

ImageTestimonial.propTypes = {
    image: PropTypes.string.isRequired,
    quote: PropTypes.string.isRequired,
    author: PropTypes.string.isRequired,
    authorDetail: PropTypes.string,
    theme: PropTypes.oneOf(['one', 'two', 'three']),
    side: PropTypes.oneOf(['right', 'left'])
};

export default ImageTestimonial;



/** WEBPACK FOOTER **
 ** ./src/ImageTestimonial/index.js
 **/